import { render, staticRenderFns } from "./letter-collection.vue?vue&type=template&id=1ea1bb9e&scoped=true"
import script from "./letter-collection.vue?vue&type=script&lang=ts"
export * from "./letter-collection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea1bb9e",
  null
  
)

export default component.exports